const controllers = []
const controllerSpecs = []

export const getControllers = element => controllers[+element.dataset.controllerIndex]

export const unlinkControllers = (element) => {
  controllers[+element.dataset.controllerIndex] = null
}

export const run = (selector, controllerFunction) => {
  controllerSpecs.push({ selector, controllerFunction })
}

export const assignController = (name, controllerFunction) => {
  controllerSpecs.push({ name, controllerFunction })
}

export const addController = (element, name) => {
  const controllerSpec = controllerSpecs.find(spec => name === spec.name)
  if (!controllerSpec) {
    return null
  }
  const controllers = getControllers(element)
  if (controllers[name]) {
    return controllers[name]
  }

  const hooks = (element.dataset.hook ? element.dataset.hook : '').split(' ')
  if (!hooks.includes(name)) {
    hooks.push(name)
  }
  element.dataset.hook = hooks.join(' ')
  const controller = instantiateController(element, controllerSpec)
  return controller
}

export const instantiateController = (element, controllerSpec) => {
  if ((typeof element.dataset.controllerIndex !== 'undefined')) {
    const existingController = getControllers(element)[controllerSpec.name]
    if (typeof existingController !== 'undefined') {
      return existingController
    }
  }
  const name = controllerSpec.name || controllerSpec.selector.replace(/[^a-zA-Z0-9]/g, '')
  if (typeof element.dataset.controllerIndex === 'undefined') {
    const elementControllers = {}
    elementControllers[name] = controllerSpec.controllerFunction(element) || null
    controllers.push(elementControllers)
    element.dataset.controllerIndex = controllers.length - 1
    return elementControllers[name]
  }
  const elementControllers = getControllers(element)
  if (typeof elementControllers[name] === 'undefined') {
    elementControllers[name] = controllerSpec.controllerFunction(element) || null
  }
  return elementControllers[name]
}

export const instantiateControllers = () => {
  controllerSpecs.forEach((controllerSpec) => {
    const elements = Array.from(document.querySelectorAll(
      controllerSpec.name
        ? `[data-hook~="${controllerSpec.name}"]`
        : controllerSpec.selector,
    )).filter(element => (typeof element.dataset.controllerIndex === 'undefined') || (typeof getControllers(element)[controllerSpec.name] === 'undefined'))
    elements.forEach((element) => {
      instantiateController(element, controllerSpec)
    })
  })
  fireControllersAvailable()
}

export const fireControllersAvailable = () => {
  controllersAvailableCallbacks.forEach(callback => callback())
  controllersAvailableCallbacks = []
}

document.addEventListener('DOMContentLoaded', instantiateControllers, {
  once: true,
})

let controllersAvailableCallbacks = []

export const controllersAvailable = (callback) => {
  controllersAvailableCallbacks.push(callback)
}

export const click = (el, fn) => {
  el.addEventListener('click', fn)
}

export const select = (element, selector) => element.querySelector(selector)

export const selectAll = (element, selector) => Array.from(element.querySelectorAll(selector))

export const selectAlso = (element, selector) => {
  const result = Array.from(element.querySelectorAll(selector))
  if (element.matches(selector)) {
    result.unshift(element)
  }
  return result
}

export const others = (item, list) => list.filter(candidate => item !== candidate)

export const listWithAncestors = (element) => {
  const list = []
  let parent = element
  do {
    list.push(parent)
    parent = parent.parentNode
  } while (parent)
  return list
}

export const setClassState = (element, stateClassName) => {
  if (!stateClassName) {
    return
  }
  stateClassName.split(' ').forEach((stateClass) => {
    element.classList.add(stateClass)
  })
}

export const unsetClassState = (element, stateClassName) => {
  if (!stateClassName) {
    return
  }
  stateClassName.split(' ').forEach((stateClass) => {
    element.classList.remove(stateClass)
  })
}

export const escapeMarkup = text => text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;')

if (!window.thundertech) {
  window.thundertech = {}
}
window.thundertech.assignController = assignController
window.thundertech.instantiateControllers = instantiateControllers
window.thundertech.getControllers = getControllers
window.thundertech.controllersAvailable = controllersAvailable
